// PGN einer gegen einen Bot gespielten Partie, für das Speichern in der Bibliothek; auch ab eigener Stellung.
export type PgnResult = '1-0' | '0-1' | '1/2-1/2' | '*';

export interface PlayedGame {
  sans: string[];
  white: string;
  black: string;
  result: PgnResult;
  event: string;
  date: Date;
  /** Startstellung, wenn die Partie nicht in der Grundstellung begann */
  fen?: string;
}

const tag = (k: string, v: string) => `[${k} "${v.replace(/"/g, "'")}"]`;

export function gamePgn(g: PlayedGame): string {
  const d = g.date;
  const date = `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  const tags = [tag('Event', g.event), tag('Site', 'Schachserver'), tag('Date', date), tag('White', g.white), tag('Black', g.black), tag('Result', g.result)];
  if (g.fen) tags.push(tag('SetUp', '1'), tag('FEN', g.fen));
  const [, turn, , , , full] = (g.fen ?? 'x w - - 0 1').split(' ');
  const first = (+full - 1) * 2 + (turn === 'b' ? 1 : 0); // Halbzug-Nummer des ersten Zugs ab 0
  const body = g.sans.map((san, i) => {
    const ply = first + i, n = Math.floor(ply / 2) + 1;
    return ply % 2 === 0 ? `${n}. ${san}` : i === 0 ? `${n}... ${san}` : san;
  }).join(' ');
  return `${tags.join('\n')}\n\n${body} ${g.result}\n`;
}
